import AirconHero from "./components/AirconHero";
import AirconWhatIs from "./components/AirconWhatIs";
import AirconConferenceTracks from "./components/AirconConferenceTracks";
import AirconProcess from "./components/AirconProcess";
import AirconPathwayNav from "./components/AirconPathwayNav";
import AirconOutcomes from "./components/AirconOutcomes";

export default function Aircon() {
  return (
    <main className="min-h-screen">
      <AirconHero />
      <AirconWhatIs />
      <AirconConferenceTracks />
      <AirconProcess />
      <AirconPathwayNav />
      <AirconOutcomes />
    </main>
  );
}